// extracted by mini-css-extract-plugin
module.exports = {"container":"SubsidyAttributes_container__1bpdh","sending":"SubsidyAttributes_sending__2qeey"};